import React, { useCallback, useEffect, useRef, useState } from 'react';
import {  Button, Card, Col, Row } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import {  useNavigate, useParams } from 'react-router-dom';
import { ChatIcon, LoaderIcon } from '../Components/Global/Icons';
import { getMyPreferenceDetails, getprojectbyidforuser } from '../Services/PtaasApiService';
import { FadeAlert, LinkButton } from '../Components/Global/Transitions';
import Tests from '../Models/Tests';
import SetupForm from '../Components/Setup/SetupForm';
import SetupProgress from '../Components/Setup/SetupProgress';
import SetupCommercials from '../Components/Setup/SetupQuote';
import ProjectTestTypes from '../Components/Overview/ProjectTestTypes';
import ProjectCommercials from '../Components/Overview/ProjectCommercials';
import { useApiErrorHandler } from '../Utilities/useApiErrorHandler';
import UsersWidget from '../Components/Users/UsersWidget';
import AccessRestricted from '../Components/Global/UnauthorizedMessage';



const ProjectSetupPage: React.FC = () => {
  
  const { id, stageid } = useParams();
  const navigate=useNavigate();
  const [status, setStatus] = useState('');
  const { instance, accounts } = useMsal();
  const [test, setTest] = useState<Tests>();
  const [project, setProject] = useState('');
  const [loading, setLoading] = useState(true);
  const [testTypes, setTestTypes] = useState([]);
  const handleChange = (stage) => {setStage(stage); navigate(`/projects/${id}/setup/${stage}`);}
  const [fetchError, setFetchError] = useState(false);
  const [chatid,setChatid]=useState('');
  const isSetup = window.location.href.includes('setup');
  const [stage, setStage] = useState(stageid ? parseInt(stageid, 10) : 1);
  const [isScoping, isCommercials, isPrereqs] = [1, 2, 3].map(s => stage === s);
  const[userinfo,setUserInfo] =useState<User>();
  const name = project + ': ' + { 1: 'Scoping', 2: 'Commercials', 3: 'Prerequisites' }[stage];
  const { error, handleApiError, clearError, isUnauthorized } = useApiErrorHandler();

  const isInitialMount = useRef(true);

  const fetchTest= useCallback(async (): Promise<void> => {
    setLoading(true);
    let returnedTest: Tests;
    try {
     
      returnedTest = await getprojectbyidforuser(instance, accounts[0], id);
      const returnedUserinfo=await getMyPreferenceDetails(instance,accounts[0]);
      setUserInfo(returnedUserinfo);
      setTest(returnedTest);
      setStatus(returnedTest?.status);
      setTestTypes(returnedTest?.testType);
      setProject(returnedTest?.projectName);
      const numericId = returnedTest?.ticketno?.replace(/\D/g, "");
      setChatid(numericId);
    } catch (err: any){
       handleApiError(err);
      setFetchError(true)
    } finally {
      setLoading(false);
    }
  },[accounts, instance,id,handleApiError]);
  
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchTest();
    }
  }, [fetchTest]);
  const handleRetry = () => {
    clearError();
    fetchTest();
  };

  // Show loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <LoaderIcon />
          <p className="mt-3 text-muted">Loading project setup...</p>
        </div>
      </div>
    );
  }

  // Show unauthorized message if API returned 403
  if (isUnauthorized) {
    return (
     <AccessRestricted title='User Management'/>
    );
  }

  // Show other errors (not 403)
  if (error) {
    return (
      <div className="p-4">
        <Card className="border-danger">
          <Card.Header className="bg-danger text-white">
            <h5 className="mb-0">Error Loading Project Setup</h5>
          </Card.Header>
          <Card.Body>
            <p className="text-danger">
              <strong>Error {error.status}:</strong> {error.message}
            </p>
            <div className="d-flex gap-2">
              <Button variant="outline-primary" onClick={handleRetry}>
                Try Again
              </Button>
              <Button variant="outline-secondary" onClick={clearError}>
                Clear Error
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }


  return (loading ? <LoaderIcon /> : (
    <>
     <Row className='mb-4 pb-3'>
      <Col sm={8} as='h1'>{project && name}</Col>
      <Col sm={4} className='text-end'>
        <LinkButton variant='secondary' to={`/messaging?id=${chatid}`}><ChatIcon />Messaging</LinkButton>
      </Col>
      </Row>
      <Row>
      <Col xl={8}>
        <FadeAlert show={fetchError} dismissFunction={() => setFetchError(false)} />
        {isScoping ? <SetupForm group='scoping' testTypes={testTypes} onStageChange={handleChange} /> : null}
         {isPrereqs ? <SetupForm group='prereq' testTypes={testTypes} onStageChange={handleChange} /> : null} 
        {isCommercials ? <SetupCommercials status={status} test={test} onStageChange={handleChange} userinfo={userinfo}/> : null}
      </Col>
      <Col xl={4}>
        <ProjectTestTypes test={test} testTypes={testTypes} isDisabled={isPrereqs} OnProjectTestTypeChange={fetchTest} />
        {isPrereqs ? <ProjectCommercials status={status} /> : null}
      <UsersWidget isdisable/>
      </Col>
      {isSetup ? <SetupProgress stage={stage} onStageChange={handleChange} /> : null}
    </Row>
    </>
  ));
};

export default ProjectSetupPage;

